var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavTruckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 25.5,
    viewBox: "0 0 30 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,27a4.5,4.5,0,0,1-9,0,3,3,0,0,1-3-3V9A3,3,0,0,1,6,6H22.5a3,3,0,0,1,3,3L30,9c3,0,3,4.344,3,6v9a3,3,0,0,1-3,3H28.5a4.5,4.5,0,0,1-9,0ZM6,9V22.5H22.5V9Zm19.5,3v6H30V12ZM24,28.5A1.5,1.5,0,1,0,22.5,27,1.5,1.5,0,0,0,24,28.5Zm-13.5,0A1.5,1.5,0,1,0,9,27,1.5,1.5,0,0,0,10.5,28.5Z",
    transform: "translate(-3 -6)",
    fill: "#2cccd3",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTruckIcon);
export default __webpack_public_path__ + "static/media/nav-truck-icon.1ef23e9f.svg";
export { ForwardRef as ReactComponent };